import React from 'react';

const NotificationIcon = props =>
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" {...props}>
    <path
      id="notifications_icon"
      data-name="notifications icon"
      d="M843.692,250.454H842.71v-4.8a4.776,4.776,0,0,0-3.865-4.722,0.484,0.484,0,0,0,0-.077,0.848,0.848,0,1,0-1.7,0,0.409,0.409,0,0,0,0,.077,4.781,4.781,0,0,0-3.868,4.722v4.8h-0.982a0.317,0.317,0,0,0-.313.322v1.707a0.317,0.317,0,0,0,.313.322h11.38a0.318,0.318,0,0,0,.313-0.322v-1.707A0.312,0.312,0,0,0,843.692,250.454ZM837.947,256a1.983,1.983,0,0,0,1.826-2.112h-3.651A1.983,1.983,0,0,0,837.947,256Z"
      transform="translate(-832 -240)"
    />
  </svg>;

export default NotificationIcon;



// WEBPACK FOOTER //
// ./app/components/notification-button/notification-icon.js